import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import GiftCardForm from 'components/RwdCheckout/Sections/Payment/GiftCardSection/GiftCardForm/GiftCardForm';
import EditDataActions from 'actions/EditDataActions';
import checkoutApi from 'services/api/checkout';
import decorators from 'utils/decorators';
import OrderActions from 'actions/OrderActions';
import { INTERSTICE_DELAY_MS } from 'constants/Checkout';
import store from 'store/Store';
import GiftCardSectionEN from 'components/RwdCheckout/Sections/Payment/GiftCardSection/locales/GiftCardSection_en_US.js';
import GiftCardSectionFR from 'components/RwdCheckout/Sections/Payment/GiftCardSection/locales/GiftCardSection_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(GiftCardSectionEN, GiftCardSectionFR);

const localization = createStructuredSelector({
    giftCardNumberText: getTextFromResource(getText, 'giftCardNumber'),
    pin: getTextFromResource(getText, 'pin'),
    apply: getTextFromResource(getText, 'apply')
});

const fields = createStructuredSelector({
    localization
});

const functions = {
    updateEditData: EditDataActions.updateEditData,
    clearEditData: sectionName => EditDataActions.clearEditData(sectionName),
    applyGiftCard: (giftCard, sectionName) => {
        return decorators
            .withInterstice(
                checkoutApi.applyGiftCard,
                INTERSTICE_DELAY_MS
            )(giftCard)
            .then(() => {
                store.dispatch(EditDataActions.clearEditData(sectionName));
                store.dispatch(OrderActions.giftCardApplied());
            });
    }
};

const withComponentProps = wrapHOC(connect(fields, functions));

export default withComponentProps(GiftCardForm);
